var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SubmitButton',{attrs:{"loading":_vm.loadings.cancelJob,"classes":"btn btn-sm btn-danger text-center btn-block"},on:{"click":function($event){$event.preventDefault();return _vm.cancelJob($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }